"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgWrenchOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M27.57 9.48L27.06 8l-4.9 4.86-.07.07c-.39.39-.5.39-.66.39a2.94 2.94 0 01-1.6-1 2.85 2.85 0 01-1-1.65c0-.17 0-.29.47-.74L24.18 5l-1.48-.51A7.73 7.73 0 0020.09 4a7.92 7.92 0 00-5.65 2.28c-3 2.95-2.84 5.77-2 7.79l-8.27 8.19a4 4 0 00-.06 5.56A3.87 3.87 0 006.86 29a3.88 3.88 0 002.74-1.13l8.19-8.12c2 .84 4.77 1 7.77-1.94A8 8 0 0028 12.15a8.24 8.24 0 00-.43-2.67zm-3.37 6.91c-2.05 2-4 2.42-6.1 1.27l-.66-.36-9.21 9.15a1.91 1.91 0 01-1.35.55 1.87 1.87 0 01-1.33-.58 1.94 1.94 0 010-2.73l8.56-8.5.67-.66-.34-.66c-1.13-2.17-.71-4.12 1.33-6.13A5.93 5.93 0 0120 6h.35l-2.51 2.5a2.83 2.83 0 00-1 2.05 4.54 4.54 0 001.55 3.09 4.54 4.54 0 003.05 1.64 2.77 2.77 0 002.06-1l2.5-2.45v.29a6.08 6.08 0 01-1.8 4.27z" })));
}
exports.default = SvgWrenchOutline;
//# sourceMappingURL=WrenchOutline.js.map